<template>
  <div
    v-auto-focus="focusCtrl"
    :data-current="currentIndex"
    :data-action="actionType"
    class="page-container"
  >
    <question class="question" index="02">{{ $t(question) }}</question>
    <input-area
      class="reason-input"
      :maxlength="1000"
      :showTipLength="940"
      :textContent.sync="reason"
      :placeholder="placeholder"
      data-index="0"
    ></input-area>
    <next-button @click="onNext" :disabled="!enableNext">{{
      $t("survey.next")
    }}</next-button>
  </div>
</template>

<script>
import Question from '../../components/Question'
import InputArea from '../../components/InputArea'
import NextButton from '../../components/NextButton'
import mixin from './mixin'
import utils from '../../utils'

export default {
  name: 'Reason',

  components: { NextButton, InputArea, Question },

  mixins: [mixin],

  data() {
    return {
      reason: '',
      focusCtrl: 0,  // 自动聚焦控制,变动时,执行自动聚焦指令
      currentIndex: 0, // 当前聚焦元素的索引
      actionType: 'next', // 自动聚焦的行为类型
    }
  },

  mounted() {
    this.checkScore()
    // this.setFocus('jump',0)
  },

  computed: {
    scoreLevel() {
      if (this.score >= 0 && this.score <= 8) {
        return 'lowScore'
      } else {
        return 'highScore'
      }
    },

    placeholder() {
      if (this.score >= 0 && this.score <= 8) {
        return `${this.$t('survey.placeholder')}\n1.\n2.\n3.`
      } else {
        return this.$t('survey.placeholder')
      }
    },

    question() {
      return `survey.reason.${this.scoreLevel}.q`
    },

    enableNext() {
      return this.reason.length > 0
    },
  },

  destroyed() {
    const nextPath = this.$route.path
    if (nextPath.includes('score')) {
      utils.native.showToast(this.$t('survey.toastTips'))
      utils.native.closeWindow()
    }
  },

  methods: {
    //点击下一步
    onNext() {
      this.$s.setReason(this.reason)
      this.reportData()
      this.$router.push({ path: 'Advice', query: { page: utils.store.getQueryVariable('page') } })
    },
    //数据上报
    reportData() {
      const sub_element_id = this.scoreLevel === 'lowScore' ? 'nps_unsatisfied_reason' : 'nps_satisfy_reason'
      // utils.native.reportEvent(
      //   {
      //     event_id: "advance_element_action",
      //     element_id: "nps_survey",
      //     sub_element_id: sub_element_id,
      //     content_id: this.reason,
      //     action: "next",
      //     page: utils.store.getQueryVariable('page')
      //   })
      gio('track', 'advance_element_action', {
        "element_id": "nps_survey",
        "sub_element_id": sub_element_id,
        "content_id": this.reason,
        "action": "next",
        "page": utils.store.getQueryVariable('page')
      });
    },
    /**
            * 控制自动聚焦指令执行
            * @param actionType {string} 自动聚焦类型 it can be 'next'/'prev'/'first'/'last'/'jump'
            * @param index {string} 当actionType为'jump'时,需要传入将要聚焦元素的索引
            **/
    setFocus(actionType, index) {
      if (actionType === 'jump') {
        this.currentIndex = index
      }
      this.focusCtrl++
      this.actionType = actionType
    },
    /**
     * 元素聚焦时,获取当前聚焦元素的索引
     * @param index {number} 当前聚焦的索引
     **/
    setFocusIndex(index) {
      this.currentIndex = index
    },

  }
}
</script>

<style lang="stylus" scoped>
.question {
  margin: 60px auto 28px;
}

.reason-input {
  margin: 0 38px;

  &:focus {
    background: red;
  }
}
</style>
